import { c as _c } from "react/compiler-runtime";
import PureHtml from "@/components/custom/PureHtml";
export default function CustomText(t0) {
  const $ = _c(2);
  const {
    ctext
  } = t0;
  const t1 = ctext?.subtext;
  let t2;
  if ($[0] !== t1) {
    t2 = <section className="py-4"><div className="max-w-7xl mx-auto px-2 py-2 bg-white rounded shadow"><div className="grid gap-3 lg:gap-4"><div><PureHtml html={t1} /></div></div></div></section>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}